import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { showNotification } from '@/utils/notificationUtils';
export type requestDTO1 = {
    filter?: any;
};

export const getDeals = (
    { filter }: requestDTO1 = {
    }
  ): Promise<any> => {
    return axios.post(`/superadmin/get-total-deals`,{filter});
  };

type UseAddUserOptions1 = {
    config?: MutationConfig<typeof getDeals>;
};

export const useGetDeals = ({ config }: UseAddUserOptions1 = {}) => {
    const { addNotification } = useNotificationStore();
    return useMutation({
        onSuccess: () => {
            // showNotification({
            //     type: 'success',
            //     title: 'Messsage sent successfully',
            // });
        },
        ...config,
        mutationFn: getDeals,
    });
};
